import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AggregateCommandAccordion = _resolveComponent("AggregateCommandAccordion")
  const _component_DialogAddAction = _resolveComponent("DialogAddAction")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.aggregateCommands, (ag, index) => {
      return (_openBlock(), _createBlock(_component_AggregateCommandAccordion, {
        key: `aggregate-command-${index}`,
        aggregateCommand: ag,
        onAddAction: _cache[1] || (_cache[1] = (action) => _ctx.openShowDialogAction(action))
      }, null, 8, ["aggregateCommand"]))
    }), 128)),
    _createVNode(_component_DialogAddAction, {
      "is-visible": _ctx.isVisibleDialogAddAction,
      "onUpdate:is-visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isVisibleDialogAddAction = $event)),
      onConfirm: _ctx.handleDoAddAction,
      actionToAdd: _ctx.tempActionToAdd
    }, null, 8, ["is-visible", "onConfirm", "actionToAdd"])
  ], 64))
}